export default __webpack_public_path__ + "static/media/dijon_logo.a961bc00.png";